import type {
    GetAllCompaniesForAdminResponseType,
    GetAllCompaniesForAdminRequestType
} from "./type";
import {
    request
} from "../request";

const getAllCompaniesForAdmin = async (
    args: GetAllCompaniesForAdminRequestType
): Promise<GetAllCompaniesForAdminResponseType> => {
    const searchParams = new URLSearchParams();

    if (args.searchText) {
        searchParams.append("searchText", args.searchText);
    }
    if (args.page !== undefined) {
        searchParams.append("page", String(args.page));
    }
    if (args.sectorIDs && args.sectorIDs.length > 0) {
        searchParams.append("sectorIDs", args.sectorIDs.join(","));
    }

    const queryStr = searchParams.toString();
    const finalUrl = queryStr ? `/company/getAllCompaniesForAdmin?${queryStr}` : "/company/getAllCompaniesForAdmin";

    return request<GetAllCompaniesForAdminResponseType>(finalUrl, {
        method: "GET"
    });
};

export default getAllCompaniesForAdmin;
